import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ManuscriptRouteGuard } from "~/pages/UploadManuscript/ManuscriptRouteGuard";
import { UploadManuscript } from "~/pages/UploadManuscript/UploadManuscript";

export const Route = createFileRoute("/_app/manuscripts/")({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.manuscripts") }],
  }),
  component: ManuscriptsRoute,
});

function ManuscriptsRoute() {
  return (
    <ManuscriptRouteGuard allowTeaser>
      <UploadManuscript />
    </ManuscriptRouteGuard>
  );
}
